import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

import { UsersHookFormSelect } from "../../components";
import { useScannerHelper } from "../../helpers";
import { useUserHookFormList } from "../../components/UsersHookFormSelect";

const CreateLaborContentEmployeeId = ({ locationId = 1 }) => {
  const { setValue, watch } = useFormContext();
  const { users } = useUserHookFormList({ locationId });
  const [scanned, setScanned] = useState(false);

  const userId = watch("userId");

  useEffect(() => {
    if (!userId || !scanned) return;

    const submitButton = document.getElementById("ModalDisplaySubmit");
    if (submitButton) submitButton.click();
  }, [userId, scanned]);

  const setEmployeeId = (barcode) => {
    const user = users?.find((u) => u?.employeeId === barcode);
    if (user?.id) {
      setValue("userId", user.id);
      setScanned(true);
    }
  };

  useScannerHelper(setEmployeeId);

  return (
    <UsersHookFormSelect
      locationId={locationId}
      onChange={() => setScanned(false)}
      useDefault={false}
      showScrollbar
    />
  );
};

export default CreateLaborContentEmployeeId;
